export default __webpack_public_path__ + "static/media/5.943bba0c.wav";